<template>
  <div class="home">
    <div class="row course-page">
      <div class="col-md-12">
        <!--begin::Portlet-->
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">Courses</h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="row" v-if="loaderlist">
              <div class="col-md-3 col-lg-3 col-xl-3 course-card">
                <div class="modern-card loading-box">
                  Data loading...
                  <facebook-loader></facebook-loader>
                </div>
              </div>
              <div class="col-md-3 col-lg-3 col-xl-3 course-card mobile-hide">
                <div class="modern-card loading-box">
                  Data loading...
                  <facebook-loader></facebook-loader>
                </div>
              </div>
              <div class="col-md-3 col-lg-3 col-xl-3 course-card mobile-hide">
                <div class="modern-card loading-box">
                  Data loading...
                  <facebook-loader></facebook-loader>
                </div>
              </div>
              <div class="col-md-3 col-lg-3 col-xl-3 course-card mobile-hide">
                <div class="modern-card loading-box">
                  Data loading...
                  <facebook-loader></facebook-loader>
                </div>
              </div>
            </div>
            <div v-if="course_count > 0" class="row">
              <div class="col-md-3 col-lg-3 col-xl-3 course-card" v-for="(item,index) in course_list" :key="index">

                  <div v-if="!item.is_bundle" class="modern-card" @click="gotoCourse(item.id, item.name, false)">

                    <div class="modern-head" :style="'background-image: url(' + (item.image) ?  '/media/course/' + item.image : '/media/course/course-1.jpg' + ') !important;'">
                      <h2>{{item.name}}</h2>
                    </div>

                    <div class="modern-stat pt-0">
                      <div class="row  modern-body-stat p-2">
                        <div class="col-12 text-center">
                           Completion Certificate
                        </div>
                      </div>
                      <div class="row pt-2">
                        <div class="col-6 text-center sub-items-border-right">
                          <span v-if="item.duration == 0">
                            {{item.duration}} Months
                          </span>
                          <span v-if="item.duration == 1">
                            {{item.duration}} Month
                          </span>
                          <span v-if="item.duration > 1">
                            {{item.duration}} Months
                          </span>                          
                        </div>
                        <div class="col-6 text-center">
                          <span v-if="item.subject_count == 0">
                            {{item.subject_count}} Subjects
                          </span>
                          <span v-if="item.subject_count == 1">
                            {{item.subject_count}} Subject
                          </span>
                          <span v-if="item.subject_count > 1">
                            {{item.subject_count}} Subjects
                          </span>
                          
                        </div>
                      </div>                     
                    </div>

                    <div class="modern-body">
                      <div class="row">
                        <div class="col-sm-12">
                          <p>
                            {{ item.description && item.description.length > 85 ? item.description.substring(0,85)+".." : item.description  }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4"></div>
                        <div class="col-md-8">
                          <div class="progress-area">
                            <span>In Progress ({{item.course_progress}}%)</span>
                            <div class="progress">
                              <div class="progress-bar" role="progressbar" :style="'width: ' + item.course_progress + '%'" :aria-valuenow="item.course_progress" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="item.is_bundle" class="modern-card bundle-course"  @click="BundleCourses(item.bundle_course,item.id,item.name)" data-toggle="modal" data-target="#online-pay-modal">

                    <div class="modern-head" :style="'background-image: url(' + (item.image) ?  '/media/course/' + item.image : '/media/course/course-1.jpg' + ') !important;'">
                      <h2>{{item.name}}</h2>
                      <div class="bundle-pack">
                        <span v-if="item.bundle_course.length > 1">
                          <span>
                            {{item.bundle_course.length}}
                          </span>
                          <b>Courses</b>
                        </span>

                         <span v-if="item.bundle_course.length == 0">
                          <span>
                            {{item.bundle_course.length}}
                          </span>
                          <b>Courses</b>
                        </span>

                          <span v-if="item.bundle_course.length == 1">
                          <span>
                            {{item.bundle_course.length}}
                          </span>
                          <b>Course</b>
                        </span>
                       
                      </div>
                    </div>

                    <div class="modern-stat pt-0">
                      <div class="row modern-body-stat-bundle-courses p-2">
                        <div class="col-12 text-center">
                          Completion Certificate
                        </div>
                      </div>
                      <div class="row pt-2">
                         <div class="col-6 text-center sub-items-border-right">
                           <span v-if="item.duration == 0">
                             {{item.duration}} Months
                           </span>
                           <span v-if="item.duration == 1">
                             {{item.duration}} Month
                           </span>
                           <span v-if="item.duration > 1">
                             {{item.duration}} Months
                           </span>
                           
                         </div>
                         <div class="col-6 text-center">
                           <span v-if="item.bundle_course.length == 0">
                              {{item.bundle_course.length}} Courses
                           </span>
                           <span v-if="item.bundle_course.length == 1">
                              {{item.bundle_course.length}} Course
                           </span>
                           <span v-if="item.bundle_course.length > 1">
                              {{item.bundle_course.length}} Courses
                           </span>
                          
                         </div>
                      </div>                     
                    </div>

                    <div class="modern-body">
                      <div class="row">
                        <div class="col-sm-12">
                          <ul>
                            <li v-for="(courses,key) in item.bundle_course" :key="key">{{key+1}}. {{courses.name}}</li>
                          </ul>
                          <!-- <p>
                            {{ item.description && item.description.length > 85 ? item.description.substring(0,85)+".." : item.description  }}
                          </p> -->
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4"></div>
                        <div class="col-md-8">
                          <div class="progress-area">
                            <br>
                            <!-- <span>In Progress ({{item.course_progress}}%)</span>
                            <div class="progress">
                              <div class="progress-bar" role="progressbar" :style="'width: ' + item.course_progress + '%'" :aria-valuenow="item.course_progress" aria-valuemin="0" aria-valuemax="100"></div>
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div class="row" v-if="no_data && course_count <= 0">
              <div class="col-md-12">
                <div class="empty-data">
                  <img src="/media/icons/empty.png" />
                  <h2>Courses not available</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Portlet-->
      </div>
    </div>
    <div class="modal fade bundle-modal" id="online-pay-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">{{course_name}}</h5>
            <img class="close" src="/media/icons/close.png" data-dismiss="modal" aria-label="Close" width="53px" />
          </div>
          <div class="modal-body">
            <div v-if="bundlecourse_list" class="row">
              <div class="col-md-6 col-lg-6 col-xl-6 course-card bundle" v-for="(item,index) in bundlecourse_list" :key="index">

                  <div v-if="!item.is_bundle" class="modern-card" data-dismiss="modal" @click="gotoCourse(item.id, item.name, true)">

                    <div class="modern-head" :style="'background-image: url(' + (item.image) ?  '/media/course/' + item.image : '/media/course/course-1.jpg' + ') !important;'">
                      <h2>{{item.name}}</h2>
                    </div>

                    <div class="modern-stat pt-0">
                      <div class="row modern-body-stat p-2">                       
                        <div class="col-12 text-center">
                           Completion Certificate
                        </div>
                      </div>
                      <div class="row pt-2">
                        <div class="col-6 text-center sub-items-border-right">
                          <span v-if="item.duration == 0">
                          {{item.duration}} Months
                          </span>
                          <span v-if="item.duration == 1">
                          {{item.duration}} Month
                          </span>
                          <span v-if="item.duration > 1">
                          {{item.duration}} Months
                          </span>
                        </div>
                        <div class="col-6 text-center">
                          <span v-if="item.subject_count == 0">
                            {{item.subject_count}} Subjects
                          </span>
                          <span v-if="item.subject_count == 1">
                            {{item.subject_count}} Subject
                          </span>
                          <span v-if="item.subject_count > 1">
                            {{item.subject_count}} Subjects
                          </span>
                          
                        </div>                       
                      </div>                      
                    </div>

                    <div class="modern-body">
                      <div class="row">
                        <div class="col-sm-12">
                          <p>
                            {{ item.description && item.description.length > 85 ? item.description.substring(0,85)+".." : item.description  }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4"></div>
                        <div class="col-md-8">
                          <div class="progress-area">
                            <span>In Progress ({{item.course_progress}}%)</span>
                            <div class="progress">
                              <div class="progress-bar" role="progressbar" :style="'width: ' + item.course_progress + '%'" :aria-valuenow="item.course_progress" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-md-12">
                <div class="empty-data">
                  <img src="/media/icons/empty.png" />
                  <h2>Courses not available</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FacebookLoader } from 'vue-content-loader';
var Config = require('../router/Config')
// var $ = require('jquery')
var Cookies = require('vue-cookies')
// var userPermissions = Cookies.get('userPermissions')

var course = {
  name: 'course',
  props: [],
  components: {
    FacebookLoader
  },
  data () {
    return {
      loaderlist:true,
      no_data:true,
      course_list: [],
      bundlecourse_list: [],
      course_count: 0,
      course_name: ''
    }
  },
  beforeCreate: function () {
    // if (!userPermissions.course_view) {
    //   this.$router.push('/')
    // }
  },
  mounted () {
    this.getCourse()
  },
  methods: {
    getCourse: function () {
      this.no_data = true;
      this.axios.get(Config.API_URL + '/api/fe/student/courses/' + Cookies.get('studentId') + '?token=' + Cookies.get('accessToken')).then(response => {
        this.loaderlist = false;
        if(response.data.res == 0) {
          this.no_data = true;
        } else {
          this.course_list = response.data.data.courses
          this.course_count = this.course_list.length
          this.no_data = false;
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    gotoCourse: function (courseId, courseName, isBundle) {
      Cookies.set('courseId', courseId)
      Cookies.set('courseName', courseName)
      Cookies.set('is_bundle', isBundle)
      this.$router.replace({ name: 'subjects' })
    },
    BundleCourses: function (Courses, bundleCourse, courseName) {
      Cookies.set('bundle_course_id', bundleCourse)
      this.bundlecourse_list = Courses
      this.course_name = courseName
    }
  }
}
export default course;
</script>

<style scoped lang="scss">
@import "../assets/scss/component/course/course";

.modal-header {
  background-color: #2C2E3E;
}

.modal .modal-content .modal-header .modal-title {
    color: #fff;
}

.modern-body-stat {
  background-color: #FFB319;
  color: #fff;
}

.modern-body-stat-bundle-courses {
  //  background-color: #F7941D;
   background-color: #FFB319;
  color: #fff;
}

.sub-items-border-right {
  border-right:1px solid rgba(0, 0, 0, 0.125);
}

.bundle-pack {
  padding: 5px;
}


</style>
